import slice, { lastPersonSigned, signingCompleted } from './reducer'
import meetingSaga from './sagas'

// Extra actions
export { lastPersonSigned, signingCompleted }

export const {
  fetchMeetingRequest: meetingRequest,
  fetchMeetingSuccess: meetingSuccess,
  fetchMeetingError: meetingError,
  meetingReset,

  fetchMeetingSilentRequest,
  fetchMeetingSilentSuccess,

  fetchMeetingParticipantsSilentRequest,
  fetchMeetingParticipantsSilentSuccess,

  patchMeetingRequest,
  patchMeetingSuccess,
  patchMeetingError,

  deleteMeetingRequest,
  deleteMeetingSuccess,
  deleteMeetingError,

  resetState,
  resetProcessing,
  setParticipantsInitiallySaved,

  sendParticipantsNoticeRequest,
  sendParticipantsNoticeSuccess,
  sendParticipantsNoticeError,

  sendParticipantNoticeToAllRequest,
  updateMeetingStatusRequested,
  updateMeetingStatusSuccess,

  fetchMeetingParticipantsForEditRequest,
  fetchMeetingParticipantsForEditError,
  fetchMeetingParticipantsForEditSuccess,
  meetingParticipantsForEditReset,

  updateMeetingResponsibleRequested,
  updateMeetingResponsibleSuccess,
  updateInvitedSendingStatus: updateMeetingInvitedSendingStatus,
  noticeEmailSent: meetingNoticeEmailSent,
} = slice.actions

export default slice.reducer
export { meetingSaga }
